import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MerchantContextService } from '../services/merchant-context.service';

/**
 * KlidiPay (shops, invoices, POS orders) is for business accounts only — Laravel kept it behind
 * its is_business middleware, and the API refuses individual accounts the same way. Hiding the
 * Business section in Individual mode isn't enough on its own: this also turns away a typed or
 * bookmarked URL.
 *
 * Runs after authGuard. In Individual mode it sends the user to the dashboard; in Business mode
 * with no business account to act as, to the overview, which offers to create one.
 */
export const businessAccountGuard: CanActivateFn = () => {
  const context = inject(MerchantContextService);
  const router = inject(Router);

  if (context.accountType() !== 'Business') return router.createUrlTree(['/dashboard']);
  if (context.selectedBusinessId() === null) return router.createUrlTree(['/business/overview']);
  return true;
};
